export const PATHS = {
  SIGNIN: 'sign-in',
  SIGNUP: 'sign-up',
  INVITECODE: 'invite-code',
  PRIVATEKEY: 'private-key',
  FEED: '/feed',
  CREATEPOST: '/post-cre',
  ADDTOHOMESCREEN: '/add-to-homescreen',
  CREATECONFIRMPASS: 'create-confirm-pass',
  MESSAGE: '/message',
}
